import React from "react";

import "./Loader.css";
const Loader = ({ size }) => {
  return <div style={{ width: size, height: size }} className="loader"></div>;
};

export default Loader;
